import React, {useEffect} from 'react'
import 'App.css'
import 'styles/colors.css'
import 'styles/typography.css'
import 'moment/locale/pl'
import 'moment/locale/en-gb'
import 'moment/locale/de'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import {MuiPickersUtilsProvider} from '@material-ui/pickers'
import {ThemeProvider, StylesProvider} from '@material-ui/core/styles'
import MomentUtils from '@date-io/moment'
import {NavigatePreventProvider} from 'context/navigatePrevent'
import {WebSocketConnectionProvider} from 'context/webSocketConnection'
import {ErrorHandlingProvider} from 'context/errorHandling'
import {AuthContextProvider} from 'context/auth'
import {UserGroupsProvider} from 'context/userGroups'
import ErrorHandler from 'components/ErrorHandler'
import {ContractorView} from 'components/Contractor'
import {AppRouter} from 'AppRouter'
import {useTranslation} from 'react-i18next'
import moment from 'moment'
import {createTheme} from '@material-ui/core'
import {AccessAuthGuardProvider} from 'context/auth/AccessAuthGuardProvider'
import {hoverColor, primaryRed} from './styles/variables'
import {GlobalDataProvider} from "./context/globalDataProvider";

const theme = createTheme({
  palette: {
    primary: {
      main: '#ed1c24',
    },
  },
  overrides: {
    MuiPickersClock: {
      pin: {
        backgroundColor: primaryRed,
      },
    },
    MuiPickersClockPointer: {
      pointer: {
        backgroundColor: primaryRed,
      },
      thumb: {
        borderColor: primaryRed,
      },
      noPoint: {
        backgroundColor: primaryRed
      }
    },
    MuiPickersDay: {
      day: {
        '&:hover': {
          backgroundColor: hoverColor
        }
      },
      daySelected: {
        backgroundColor: primaryRed,
        '&:hover': {
          backgroundColor: '#cd1c24'
        }
      },
      current: {
        color: primaryRed,
      },
    },
    MuiAutocomplete:{

      option:{
        '&[aria-selected="true"]': {
          fontStyle: 'italic',
          fontWeight: '500',
          // color: '#868484',
          borderBottom:'solid 1px lightgray'
        },
      }
    }
  },
})

export default function App() {
  const {i18n} = useTranslation()

  useEffect(() => {
    moment.locale(i18n.language)
  }, [i18n.language])

  return (
    <ErrorHandlingProvider>
      <MuiPickersUtilsProvider utils={MomentUtils} locale={i18n.language}>
        <StylesProvider injectFirst>
          <ThemeProvider theme={theme}>
            <AuthContextProvider>
              <GlobalDataProvider>
                <WebSocketConnectionProvider>
                  <Router>
                    <NavigatePreventProvider>
                      <div className="App">
                        <Switch>
                          <Route path="/contractor-view/:orderToken"
                                 component={ContractorView}/>
                          <AccessAuthGuardProvider>
                            <UserGroupsProvider>
                              <Route component={AppRouter}/>
                            </UserGroupsProvider>
                          </AccessAuthGuardProvider>
                        </Switch>
                        <ErrorHandler/>
                      </div>
                    </NavigatePreventProvider>
                  </Router>
                </WebSocketConnectionProvider>
              </GlobalDataProvider>
            </AuthContextProvider>
          </ThemeProvider>
        </StylesProvider>
      </MuiPickersUtilsProvider>
    </ErrorHandlingProvider>
  )
}
